import { SEARCH_DEBOUNCE_DELAY } from '@repo/commons/constants'
import { createDebouncer } from '@repo/commons/utils'

type SearchTextGetter<T> = (row: T) => string | undefined

export class DebouncedSearch {
	query = $state('')

	#debounceQueryUpdate = createDebouncer(SEARCH_DEBOUNCE_DELAY)

	updateQuery = (value: string): void => {
		const query = value.trim()

		if (!query) this.query = ''

		this.#debounceQueryUpdate(() => {
			this.query = query
		})
	}

	filterRows = <T>(rows: readonly T[], getText: SearchTextGetter<T>): T[] => {
		const query = this.query.toLowerCase()

		if (!query) return [...rows]

		return rows.filter((row) => (getText(row) ?? '').toLowerCase().includes(query))
	}
}
